import Employee from 'src/app/model/product/employee';
import * as moment from 'moment';
import { GeneralHelper } from 'src/app/helpers/general-helper';

export class DisplayNotExecutedHistoryItemHelper {
  private constructor() {}

  static verifyHowToHandle(
    selectedHandleOption: HowToHandleOption,
    newTourEmployee: Employee,
    newTourDate: moment.Moment
  ): string {
    if (selectedHandleOption == null) {
      return 'Gelieve een optie te kiezen voor hoe deze opdracht verder af te handelen';
    }

    if (
      selectedHandleOption === HowToHandleOption.REMOVE_FROM_CURRENT_TOUR &&
      !GeneralHelper.equivalentNullState(newTourEmployee, newTourDate)
    ) {
      return 'Indien u de opdracht meteen wil inplannen in een andere toer, gelieve zowel installateur als datum te kiezen';
    }

    return null;
  }
}

export enum HowToHandleOption {
  RESCHEDULE_APPOINTMENT,
  DELAY,
  REMOVE_FROM_CURRENT_TOUR,
  INVOICE_PARTIALLY,
  SET_STATUS_TO_EXECUTED,
  SET_STATUS_TO_NOT_EXECUTED
}
